{
  "alerts": [
    {
      "type": "ClaimStatus",
      "title": "Claim status",
      "description": "The claim status field has changed",
      "favorite": true,
      "lobs": ["WC", "DS", "GL", "AU", "PR"]
    },
    {
      "type": "TotalIncurred",
      "title": "Total incurred",
      "description": "The total incurred amount has changed",
      "favorite": true,
      "lobs": ["WC", "GL", "AU", "PR"]
    },
    {
      "type": "ClaimDateOpen",
      "title": "Claim open date",
      "description": "The claim open date changed to a date within the selected range",
      "favorite": true,
      "lobs": ["WC", "DS", "GL", "AU", "PR"]
    },
    {
      "type": "AdjusterChange",
      "title": "Examiner has changed",
      "description": "The examiner assigned to the claim has changed",
      "favorite": true,
      "lobs": ["WC", "DS", "GL", "AU", "PR"]
    },
    {
      "type": "ReserveChange",
      "title": "Total future reserve",
      "description": "The total future reserve amount has changed",
      "favorite": true,
      "lobs": ["WC", "GL", "AU", "PR"]
    },
    {
      "type": "BenefitStatus",
      "title": "Benefit status",
      "description": "The benefit status has been changed",
      "favorite": false,
      "lobs": ["WC", "DS"]
    },
    {
      "type": "CauseCode",
      "title": "Cause code",
      "description": "The cause coding has changed",
      "favorite": false,
      "lobs": ["WC", "GL", "AU", "PR"]
    },
    {
      "type": "Litigation",
      "title": "Claim litigation",
      "description": "The claim litigation flag has changed",
      "favorite": false,
      "lobs": ["WC", "GL", "AU", "PR"]
    },
    {
      "type": "ClaimReopened",
      "title": "Claim reopened",
      "description": "The claim has been reopened",
      "favorite": false,
      "lobs": ["WC", "DS", "GL", "AU", "PR"]
    },
    {
      "type": "Subrogation",
      "title": "Claim subrogation",
      "description": "The claim subrogation flag has changed",
      "favorite": false,
      "lobs": ["WC", "GL", "AU", "PR"]
    },
    {
      "type": "ClaimType",
      "title": "Claim type",
      "description": "The claim type has changed",
      "favorite": false,
      "lobs": ["WC"]
    },
    {
      "type": "PolicyDeductibleSirRange",
      "title": "Claim/event within policy deductible or SIR",
      "description": "The paid or incurred amount reaches a defined percentage of the policy deductible or self-insured retention amount. Choose whether to use paid or incurred values. The system applies the policy deductible or self-insured retention (SIR) at the event level based on policy information.",
      "favorite": false,
      "lobs": ["WC", "GL", "AU", "PR"],
      "labelCase": "none",
      "dailyOnly": true
    },
    {
      "type": "ClaimantDeceased",
      "title": "Claimant death",
      "description": "The claimant's date of death has changed",
      "favorite": false,
      "lobs": ["WC", "GL", "AU", "PR"]
    },
    {
      "type": "MultipleOpenClaims",
      "title": "Multiple open claims",
      "description": "The claimant, identified by Social Security Number, has multiple open claims",
      "favorite": false,
      "lobs": ["WC", "DS", "GL", "AU", "PR"],
      "labelCase": "none"
    },
    {
      "type": "CalendarLostDays",
      "title": "Current off work days",
      "description": "Number days since employee went off work in the current period",
      "favorite": false,
      "lobs": ["WC", "DS"],
      "dailyOnly": true
    },
    {
      "type": "CalendarRestrictedDays",
      "title": "Current restriction days",
      "description": "Number of days since the employee was last placed on work restrictions or restrictions with no time loss (NTL)",
      "favorite": false,
      "lobs": ["WC", "DS"],
      "labelCase": "none",
      "dailyOnly": true
    },
    {
      "type": "ClientDefinedField",
      "title": "Custom field",
      "description": "Monitor when a client-defined custom field value changes or matches selected criteria",
      "favorite": false,
      "lobs": ["WC", "DS", "LA", "AU", "GL", "PR"]
    },
    {
      "type": "DefenseAttorneyChanged",
      "title": "Defense representing attorney",
      "description": "The defense representing attorney's name has changed",
      "favorite": false,
      "lobs": ["WC", "AU", "GL", "PR"]
    },
    {
      "type": "PolicyLimit",
      "title": "Event within policy limit",
      "description": "The event's paid or incurred amount reaches a defined percentage of the policy limit. Choose whether to use paid or incurred values. Because policy limits are typically applied per occurrence, this condition is evaluated at the event level only.",
      "favorite": false,
      "lobs": ["WC", "GL", "AU", "PR"],
      "labelCase": "none",
      "dailyOnly": true
    },
    {
      "type": "ExcessNotificationDate",
      "title": "Excess notification",
      "description": "The excess notification date changed to a date within the number of days selected from today",
      "favorite": false,
      "lobs": ["WC", "GL", "AU", "PR"]
    },
    {
      "type": "IndividualHasClaimCase",
      "title": "Individual has a new claim or case",
      "description": "A new claim or case has been associated with a selected individual, matched by employee number, Social Security Number or an existing claim. With HR data feed: select any employee. Without HR data feed: only individuals with existing Juris claims can be selected.",
      "favorite": false,
      "lobs": ["WC", "DS", "LA", "GL", "AU", "PR"],
      "labelCase": "none"
    },
    {
      "type": "LagTimeAlerts",
      "title": "Lag time",
      "description": "Calculate the lag time between two selected dates. Select your from and to date fields, then set the number of days threshold.",
      "favorite": false,
      "lobs": ["WC", "GL", "AU", "PR"],
      "labelCase": "none"
    },
    {
      "type": "LegalCaseResolved",
      "title": "Legal case resolved",
      "description": "The legal case has been resolved",
      "favorite": false,
      "lobs": ["WC", "GL", "AU", "PR"]
    },
    {
      "type": "AggregateCalendarLostDays",
      "title": "Lost time days",
      "description": "Total number of days the employee has been off work",
      "favorite": false,
      "lobs": ["WC", "DS"],
      "dailyOnly": true
    },
    {
      "type": "LostTimeGuidelines",
      "title": "Lost time guidelines",
      "description": "The claimant's time away from work meets or exceeds an ICD threshold: mid-range, at-risk, or at-risk minus 7 days",
      "favorite": false,
      "lobs": ["WC", "DS"],
      "labelCase": "none",
      "dailyOnly": true
    },
    {
      "type": "EventMultipleClaimants",
      "title": "Multiple claimants",
      "description": "The event has multiple claimants",
      "favorite": false,
      "lobs": ["WC", "DS", "GL", "AU", "PR"]
    },
    {
      "type": "NatureResult",
      "title": "Nature/Result code",
      "description": "The nature of injury or results of property damage/collision coding has changed",
      "favorite": false,
      "lobs": ["WC", "GL", "AU", "PR"],
      "labelCase": "none"
    },
    {
      "type": "BodyPart",
      "title": "Part/Target code",
      "description": "The body part or target of property damage/collision coding has changed",
      "favorite": false,
      "lobs": ["WC", "GL", "AU", "PR"],
      "labelCase": "none"
    },
    {
      "type": "PaymentAmount",
      "title": "Payment amount",
      "description": "Allocation amount changed for a single allocation",
      "favorite": false,
      "lobs": ["WC", "DS", "GL", "AU", "PR"]
    },
    {
      "type": "PaymentPayCode",
      "title": "Payment codes",
      "description": "The pay code for a single payment allocation is changed",
      "favorite": false,
      "lobs": ["WC", "DS", "GL", "AU", "PR"]
    },
    {
      "type": "PermanentTotalDisability",
      "title": "Permanent total disability",
      "description": "Injury type is set to permanent total disability",
      "favorite": false,
      "lobs": ["WC"]
    },
    {
      "type": "PlaintiffAttorney",
      "title": "Plaintiff representing attorney",
      "description": "The plaintiff representing attorney's name has changed",
      "favorite": false,
      "lobs": ["WC", "GL", "AU", "PR"]
    },
    {
      "type": "AggregateCalendarRestrictedDays",
      "title": "Restricted duty days",
      "description": "Total number of days the employee has been on restricted duty and restricted no loss-time (NTL)",
      "favorite": false,
      "lobs": ["WC", "DS"],
      "labelCase": "none",
      "dailyOnly": true
    },
    {
      "type": "TCMOpenReferralDays",
      "title": "TCM referral days",
      "description": "This alert triggers when the number of days since an accepted telephonic case management (TCM) referral was opened reaches your set value. Each open, accepted referral can trigger an alert. Closed or rejected referrals are excluded.",
      "favorite": false,
      "lobs": ["WC"],
      "labelCase": "none",
      "dailyOnly": true
    },
    {
      "type": "WorkStatus",
      "title": "Work status",
      "description": "The work status has changed",
      "favorite": false,
      "lobs": ["WC", "DS"]
    }
  ]
}
